export default {"src":"/_next/static/media/constLogo4.f255a06b.svg","height":81,"width":250,"blurWidth":0,"blurHeight":0};